const { connect } = require("react-redux");
// @ components
const BrokerCustomWalletConfigurationHeader = require ('./brokerCustomWalletConfigurationHeader');

module.exports.BrokerCustomWalletConfigurationHeader = connect(
    state => ({
        immBrokerCustomWalletPortfolios: state.brokerCustomWalletPortfolios
    }), null
)(BrokerCustomWalletConfigurationHeader);